/* petioz-fixes.js — loaded after the theme so it wins.
   Fix: selecting a colour swatch did not change the main gallery image.
   Cause: variant image URLs render protocol-relative (//shop/cdn/...) while a
   DOM img.src always resolves absolute (https://shop/cdn/...), so the buy box's
   string comparison never matched. Match on the filename instead, and drive the
   gallery from the COLOUR so it still works when the selected colour+size
   combination does not exist as a variant. */
(function () {
  if (window.__ptzFixesBound) return;
  window.__ptzFixesBound = true;

  function imgKey(u) {
    return (u || '').split('?')[0].split('/').pop()
      .replace(/_\d+x\d*(?=\.)/, '').toLowerCase();
  }

  function wire(root) {
    if (root.dataset.ptzGalleryFixed) return;

    var dataEl = null;
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var s = 0; s < scripts.length; s++) {
      var attrs = scripts[s].attributes;
      for (var a = 0; a < attrs.length; a++) {
        if (attrs[a].name.indexOf('data-ptz-vdata') === 0) { dataEl = scripts[s]; break; }
      }
      if (dataEl) break;
    }
    if (!dataEl) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var mains  = root.querySelectorAll('[data-ptz-main]');
    var thumbs = root.querySelectorAll('[data-ptz-thumb]');
    var dots   = root.querySelectorAll('[data-ptz-dot]');
    if (!mains.length) return;

    var keys = [];
    for (var i = 0; i < mains.length; i++) keys.push(imgKey(mains[i].getAttribute('src')));

    var colorMedia = {};
    for (var j = 0; j < variants.length; j++) {
      var c = variants[j].o1;
      if (c == null || c in colorMedia || !variants[j].img) continue;
      var at = keys.indexOf(imgKey(variants[j].img));
      if (at >= 0) colorMedia[c] = at;
    }
    if (!Object.keys(colorMedia).length) return;

    function show(n) {
      for (var i = 0; i < mains.length; i++) mains[i].classList.toggle('is-active', i === n);
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-active', t === n);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === n);
      var th = thumbs[n];
      if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-ptz-color]') : null;
      if (!btn || !root.contains(btn)) return;
      var idx = colorMedia[btn.getAttribute('data-ptz-color')];
      if (typeof idx === 'number') setTimeout(function () { show(idx); }, 0);
    });

    var active = root.querySelector('[data-ptz-color].is-active');
    if (active) {
      var start = colorMedia[active.getAttribute('data-ptz-color')];
      if (typeof start === 'number') show(start);
    }

    root.dataset.ptzGalleryFixed = '1';
  }

  function run() {
    var roots = document.querySelectorAll('[id^="ptz-bb-"]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
